<template>
    <a-list-item
        class="tower-card" :style="{ borderColor: color.primary }"
    >
        <a-list-item-meta>
            <cover slot="avatar" v-bind="tower" />
            <div slot="description" class="tower-card-main">
                <div></div>
            </div>
        </a-list-item-meta>
    </a-list-item>
</template>

<script>
import Cover from '../../components/Cover.vue';
import { COLORS } from '../../constant';

export default {
    props: [ 'tower' ],
    computed: {
        color() {
            return COLORS[this.tower.color];
        },
    },
    components: {
        Cover,
    },
}
</script>

<style lang="less" scoped>
.tower-card.ant-list-item {
    width: fit-content;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 10px;
    margin-bottom: 10px;
    border-radius: 2px;
    border-left: 10px solid;
    border-bottom: none;
}
.ant-list-item-meta-avatar {
    margin-right: 0;
}
</style>